// Use absolute paths only.

export const PublicRoute = {
  maintenance: "/maintenance",
  troubleshootingIhd: "/troubleshooting-ihd",
  movingIn: "/moving-in",
  ourTariffs: "/our-tariffs",
} as const

export type PublicRoute = (typeof PublicRoute)[keyof typeof PublicRoute]
